import { Outlet } from "react-router-dom";
import { useIsDesktopAdmin } from "@/hooks/useIsDesktopAdmin";
import { DesktopAdminLayout } from "./DesktopAdminLayout";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/contexts/AuthContext";
import { SACustomerContextBar } from "@/components/sa/company/SACustomerContextBar";
import { AppFooter } from "@/components/AppFooter";
import { DailyCheckAccessGate } from "@/components/DailyCheckAccessGate";

export function DesktopAdminWrapper() {
  const { isDesktopAdmin } = useIsDesktopAdmin();
  const navigate = useNavigate();
  const { toast } = useToast();
  const { markManualLogout } = useAuth();

  const handleLogout = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: driver } = await supabase
          .from("drivers")
          .select("id")
          .eq("user_id", user.id)
          .maybeSingle();
        if (driver) {
          await supabase.from("drivers").update({ is_active: false }).eq("id", driver.id);
        }
      }
    } catch (error) {
      console.error('[Logout] Error:', error);
    }
    markManualLogout();
    await supabase.auth.signOut();
    toast({ title: "Logged out", description: "You've been successfully logged out." });
    navigate("/auth");
  };

  if (!isDesktopAdmin) {
    return (
      <>
        <SACustomerContextBar />
        <main id="main-content">
          <DailyCheckAccessGate><Outlet /></DailyCheckAccessGate>
        </main>
        <AppFooter />
      </>
    );
  }

  return (
    <DesktopAdminLayout onLogout={handleLogout}>
      <SACustomerContextBar />
      <DailyCheckAccessGate><Outlet /></DailyCheckAccessGate>
    </DesktopAdminLayout>
  );
}
